import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { TermScheduleFlags } from '../../services/term_schedule_flags';
import { Section } from '../../../sections/builders/section_builder';
import { ScheduledSectionsQuery } from '../../queries/scheduled_sections_query';
import { ISection, ISectionType } from '../../../../interfaces/scheduler_interfaces';
const _4 = require('lodash4');
import { MultiSectionServant } from '../../servants/multi_section_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';

class MultiSectionSectionsRequiredTileMessage {
  private section: ISection;
  private sectionTypeNames: string;
  private message: string | null;
  private showSectionsRequired: boolean;
  private waitlistedSectionDisplayText: string;
  private codeRequiredSectionDisplayText: string;
  constructor(
    private ngMultiSectionServant: MultiSectionServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant
  ) {
    this.waitlistedSectionDisplayText = '(Waitlisted)';
    this.codeRequiredSectionDisplayText = '(Code Required)';
  }

  getSectionTypeNameForRegisteredSection(section: ISection): string {
    // Sibling Sections of not same status.
    const siblingSections = this.ngMultiSectionServant.getTiedNonRegisteredRequiredSections(
      section,
      this.ngScheduledSectionsQuery.result.list
    );

    const getSectionMessage = (regSection: ISection, isWaitlisted: boolean): string => {
      const requiredMessage = isWaitlisted ? this.waitlistedSectionDisplayText : ``;
      return `${regSection._section_type.name}${requiredMessage}`;
    };
    const regSections = _4.compact([...siblingSections]);
    return _4(regSections)
      .sortBy((sec: ISection) => sec._section_type.rank)
      .uniqBy('section_type')
      .map((sec: ISection): string => getSectionMessage(sec, ScheduledSectionServant.isSectionWaitListed(sec)))
      .value()
      .join(', ');
  }

  getSectionTypeNameForScheduledSection(section: ISection): string {
    const sections = this.ngMultiSectionServant.getSiblingWaitlistedSections(
      section,
      this.ngScheduledSectionsQuery.result.waitlistedSections
    );
    return _4(sections)
      .uniqBy('section_type')
      .map('_section_type')
      .compact()
      .sortBy('rank')
      .map((sectionType: ISectionType) => `${sectionType.name} ${this.waitlistedSectionDisplayText}`)
      .value()
      .join(`, `);
  }

  getSectionTypeNames(section: ISection): string {
    if (this.ngMultiSectionServant.isRegisteredMultiSection(section)) {
      return this.getSectionTypeNameForRegisteredSection(section);
    }
    // SCHEDULED, we need to show waitlisted section types in this case
    else if (ScheduledSectionServant.isSectionWaitListed(section)) {
      return ``;
    } else {
      const sectionTypeNames = this.getSectionTypeNameForScheduledSection(section);
      return sectionTypeNames;
    }
  }

  initialize() {
    const isStatusRegisteredOrCompleteOrInProgress =
      this.ngScheduledSectionStatusServant.isStatusRegisteredOrCompleteOrInProgress(this.section);

    if (this.ngMultiSectionServant.isRegisteredMultiSection(this.section)) {
      this.message = 'Register all required sections promptly to avoid automatic drop of this course.';
    }
    const areAllMultiSectionsRegistered = this.ngMultiSectionServant.areAllMultiSectionsRegistered(
      this.section,
      this.ngScheduledSectionsQuery.result.list
    );
    const hasUnscheduledRequiredSiblingSections = this.ngMultiSectionServant.hasUnscheduledRequiredSiblingSections(
      this.section,
      this.ngScheduledSectionsQuery.result.list
    );

    this.showSectionsRequired =
      isStatusRegisteredOrCompleteOrInProgress &&
      hasUnscheduledRequiredSiblingSections &&
      !areAllMultiSectionsRegistered;
  }

  $onInit() {
    this.initialize();
  }

  $onChanges(changes: { section: ISection }) {
    this.initialize();
  }
}

class MultiSectionSectionsRequiredTile implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = MultiSectionSectionsRequiredTileMessage;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/multi_section_sections_required_tile/multi_section_sections_required_tile.html';
  }
}

angular
  .module('capability-ng-scheduler')
  .component('multiSectionSectionsRequiredTile', new MultiSectionSectionsRequiredTile());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/multi_section_sections_required_tile/multi_section_sections_required_tile.ts